<template>
  <div id="dashboard-analytics">
    <vx-card class="vx-col w-full md:w-1/1 lg:w-1/1 xl:w-1/1 mb-base">
      <div class="w-full block items-center md:flex">
        <div class="w-5/12">
          <b class="w-full">Filtrar dados por periodo</b>
          <div class="w-full mt-2 items-center hidden md:block">
            <span class="text-sm">Atualização Automática</span>
            <vs-select v-model="autoSync" icon="schedule" width="150px" size="small">
              <vs-select-item :key="1" :value="false" text="Desligado"/>
              <vs-select-item :key="2" :value="1" text="1 Min"/>
              <vs-select-item :key="5" :value="5" text="5 Min"/>
              <vs-select-item :key="10" :value="10" text="10 Min"/>
            </vs-select>
          </div>
        </div>

        <div class="flex w-5/12 sm:mt-5">
          <flat-pickr
            ref="initial"
            style="width: 8rem"
            v-model="initial_date"
            placeholder="Intervalo inicial"
            :config="initialConfigdateTimePicker"
          />
          <flat-pickr
            class="ml-2"
            ref="final"
            style="width: 8rem"
            v-model="finish_date"
            placeholder="Intervalo final"
            :config="finalConfigdateTimePicker"
          />
        </div>

        <div class="flex w-8/12 mt-2">
          <div class="grid grid-cols-1 md:grid-cols-2">
            <vs-checkbox v-model="showTenantInput"> <small>Nome da Plataforma</small> </vs-checkbox>
            <vs-checkbox v-model="filters.categories.active"  v-if="isControlPanel"> <small>Categoria Específica</small> </vs-checkbox>
            <vs-checkbox v-model="filters.instances.active" v-if="isControlPanel"> <small>Conexão Específica</small> </vs-checkbox>
            <vs-checkbox v-model="filters.excludeCustomers.active" v-if="isMariaPanel"> <small>Excluir Contatos Específicos</small> </vs-checkbox>
          </div>
        </div>

        <div class="flex mt-2">
          <vx-tooltip class="align-self-center hidden md:block" text="Essa função está em testes, pode ocorrer de não carregar todos os dados quando for um intervalo de tempo maior.">
            <feather-icon icon="HelpCircleIcon"/>
          </vx-tooltip>
          <vs-button class="ml-2 mr-1" @click="filterDateAnalytics()" :disabled="buttonDisabled || !canFilter">
            Filtrar
          </vs-button>
        </div>
      </div>
    </vx-card>

    <vx-card class="vx-col w-full md:w-1/1 lg:w-1/1 xl:w-1/1 mb-base">
      <div class="grid grid-cols-1 gap-4 md:gap-6 md:grid-cols-2" :class="'xl:grid-cols-' + countFilter">
        <div v-if="showTenantInput" class="p-3 rounded-lg shadow">
          <div class="flex items-start w-full">
            <div class="ml-4 flex-1 w-full">
              <h3 class="text-lg font-semibold mb-2">
                🔍 Busca por Nome da Plataforma
              </h3>
              <div class="text-sm space-y-2">
                <p class="leading-relaxed">
                  Digite o início do nome da Plataforma (ex: <code class="px-1 rounded text-xs">"drogaria"</code>) para buscar todos que começam com esse termo.
                </p>
                <div class="bg-white p-3 rounded-md border">
                  <p class="font-medium mb-1">💡 Como funciona:</p>
                  <p class="text-xs leading-relaxed">
                    É uma busca inteligente que encontrará as plataformas que "começam com". <br>
                    Exemplo: digitando "drogaria" busca <code class="px-1 rounded text-xs">drogaria</code>,
                    incluirá as plataformas como <code class="px-1 rounded text-xs">drogaria-do-bairro</code>,
                    <code class="px-1 rounded text-xs">drogaria-centro</code>, etc.
                  </p>
                </div>
              </div>
              <div class="mt-4">
                <label for="tenantInput" class="block text-sm font-medium mb-2">
                  Nome da Plataforma:
                </label>

                <vs-input
                  id="tenantInput"
                  v-model="tenantInput"
                  placeholder="Ex: drogaria, farmacia, clinica..."
                  class="w-full rounded-lg"
                  size="small"
                />
                <p v-if="tenantInput && !isTenantInputValid" class="text-xs mt-1 text-danger">
                  Nome inválido. Deve ter pelo menos 5 caracteres e corresponder a uma plataforma existente.
                </p>
                <p class="text-xs mt-1 italic">
                  Digite apenas o início do nome (sem espaços ou caracteres especiais)
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="p-3 rounded-lg shadow">
          <tenants-slim-list checkbox :selecteds="hostnames" @selectedTenant="hostnamesChanged" />
        </div>
        <div v-if="filters.categories.active" class="p-3 rounded-lg shadow">
          <customer-category-slim-list checkbox search name="Categoria" :selectedTenants="hostnames" :selecteds="categoriesSelected" @selectedGroup="selectCategory" />
        </div>
        <div v-if="filters.instances.active" class="p-3 rounded-lg shadow">
          <instances-slim-list checkbox search name="Conexões" :selectedTenants="hostnames" :selecteds="instancesSelected" @selectedGroup="selectInstance" />
        </div>
        <div v-if="filters.excludeCustomers.active" class="p-3 rounded-lg shadow">
          <customers-slim-list checkbox search name="Contatos" :selectedTenants="hostnames" :selecteds="excludeCustomersIdSelected" @selectedGroup="selectExcludeCustomersId"/>
        </div>
      </div>
    </vx-card>

    <div v-for="(value, index) in dashFilter" :key="index">
      <iframe
        ref="iframe"
        scrolling="no"
        allowtransparency
        :src="value[1]['url']"
        class="iframe mb-5"
        :class="'iframe-'+value[0]"
      ></iframe>
    </div>
  </div>
</template>
<script>

import jwt from 'jsonwebtoken';
import flatPickr from 'vue-flatpickr-component';
import TenantsSlimList from "../Tenants/TenantsSlimList.vue";
import VxTimeline from "@/components/timeline/VxTimeline"
import CustomerCategorySlimList from "@/views/customer-groups/CustomerCategorySlimList.vue";

import 'flatpickr/dist/flatpickr.css';

import {mapGetters} from "vuex";
import {delay} from "@/utils";
import InstancesSlimList from "@/views/instances/InstancesSlimList.vue";
import CustomersSlimList from "@/views/customers/CustomersSlimList.vue";

export default {
  components: {CustomersSlimList, InstancesSlimList, CustomerCategorySlimList, TenantsSlimList, VxTimeline, flatPickr},
  data() {
    return {
      hostnames: [],
      instancesSelected: [0],
      categoriesSelected: [0],
      excludeCustomersIdSelected: [0],
      autoSync: false,
      autoSyncData: null,
      initial_date: null,
      finish_date: null,
      buttonDisabled: false,
      showTenantInput: false,
      tenantInput: null,
      initialConfigdateTimePicker: {
        enableTime: false,
        noCalendar: false,
        dateFormat: 'd/m/Y',
        maxDate: new Date(),
        onChange: this.calendaChange
      },
      finalConfigdateTimePicker: {
        enableTime: false,
        noCalendar: false,
        minDate: null,
        maxDate: new Date(),
        dateFormat: 'd/m/Y',
      },
      filters: {
        instances : { active: false },
        categories : { active: false },
        departments : { active: false },
        excludeCustomers : { active: false }
      },
      typesOfDash: {
        'campaigns'     : { dashboard: 87, url: null },
        'dafault'       : { dashboard: 8,  url: null },
        'cloud'         : { dashboard: 9,  url: null },
        'control-panel' : { dashboard: 18, url: null },
        'maria'         : { dashboard: 89, url: null },
      },
      payload: {
        resource: {},
        params: {},
        exp: Math.round(Date.now() / 1000) + (1024 * 920)
      },
    }
  },
  computed: {
    ...mapGetters(['token', 'tenants']),
    isTenantInputValid() {
      if (!this.tenantInput || this.tenantInput.length < 5) return false;
      return this.tenants.some(tenant => {
        const prefix = (tenant && tenant.fqdn ? tenant.fqdn.split(".")[0] : '').toLowerCase();
        return prefix.startsWith(this.tenantInput.toLowerCase());
      });
    },
    canFilter() {
      if (this.showTenantInput) { return this.isTenantInputValid; }
      return this.hostnames.length > 0;
    },
    initialDate(){
      return this.stringToDate(this.initial_date,"dd/MM/yyyy","/");
    },
    isControlPanel(){
      return this.$route.name && this.$route.name.includes('control-panel')
    },
    isMariaPanel(){
      return this.$route.name && this.$route.name.includes('maria-panel')
    },
    finishDate(){
      let finishedDate = this.stringToDate(this.finish_date,"dd/MM/yyyy","/")
      finishedDate.setHours(23,59,59, 9998)
      return finishedDate;
    },
    countFilter(){
      return Object.entries(this.filters).filter(filter => filter && filter[1].active ).length + 1;
    },
    dashFilter(){
      return Object.entries(this.typesOfDash).filter(([key]) => {
        return (
          (this.isMariaPanel && key === 'maria') ||
          (this.isControlPanel && key === 'control-panel') ||
          (!this.isControlPanel && !this.isMariaPanel && ['dafault', 'cloud', 'campaigns'].includes(key))
        )
      });
    }
  },
  watch: {
    '$route.name'(value){
      if (value){
        this.clear();
        this.loadMetabase();
      }
    },
    hostnames(value){
      this.buttonDisabled = !value.length
    },
    showTenantInput(value){
      this.hostnames = [];
      if (!value){ this.tenantInput = null; }
    },
    'filters': {
      deep: true,
      handler(value) {
        const disables = Object.entries(value).filter(filter => !filter[1].active );
        if (disables.length === 0) return;
        disables.forEach((disable) => this[disable[0] + 'Selected'] = [0]);
      }
    },
    autoSync(minutes){
      if (minutes){
        clearInterval(this.autoSyncData);
        this.autoSyncData = setInterval(() => {
          this.filterDateAnalytics();
        }, minutes * 60000)
      } else {
        clearInterval(this.autoSyncData);
        this.autoSyncData = null;
      }
    },
    tenantInput(value) {
      const formatted = value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9\s-]/g, "").replace(/\s+/g, '-').replace(/-+/g, '-');

      if (value && value !== formatted) {
        this.tenantInput = formatted;
      }
      if (this.showTenantInput) {
        if (value) {
          const filtered = this.tenants.filter(tenant => { return (tenant && tenant.fqdn ? tenant.fqdn.split(".")[0] : '').toLowerCase().startsWith(value) });
          this.hostnames = filtered.map(t => t.id);
        } else {
          this.hostnames = [];
        }

        this.clear(false);
      }
    }
  },
  methods: {
    delay,
    stringToDate(_date,_format,_delimiter){
      let formatLowerCase = _format.toLowerCase();
      let formatItems = formatLowerCase.split(_delimiter);
      let dateItems = _date.split(_delimiter);
      let dayIndex = formatItems.indexOf("dd");
      let monthIndex = formatItems.indexOf("mm");
      let yearIndex = formatItems.indexOf("yyyy");
      let month = parseInt(dateItems[monthIndex]);
      month-=1;

      return new Date(dateItems[yearIndex],month,dateItems[dayIndex]);
    },
    verify(){
      const permissions = localStorage.getItem('permissions');
      const twoFactor = localStorage.getItem('twoFactor')
      if(!permissions && !twoFactor){
          this.$router.push('/user-settings')
      }else if(!permissions && twoFactor){
          this.$router.push('/two-factor')
      }
    },
    calendaChange(selectedDates) {
      const start = selectedDates[0];
      const today = new Date();

      let maxAllowed = today;
      if (this.isControlPanel) {
        const FIFTEEN_DAYS_MS = 14 * 24 * 60 * 60 * 1000;
        maxAllowed = new Date(start.getTime() + FIFTEEN_DAYS_MS);
        if (maxAllowed > today) maxAllowed = today;
      }

      const fp = this.$refs.final.fp;
      fp.set('minDate', start);
      fp.set('maxDate', maxAllowed);

      if (this.finalDate) {
        const end = Array.isArray(this.finalDate) ? this.finalDate[0] : this.finalDate;
        if (end < start || end > maxAllowed) {
          this.finalDate = null;
        }
      }
    },
    hostnamesChanged(selected){
      this.hostnames = selected;
    },
    selectCategory(category){
      this.categoriesSelected = category
    },
    selectInstance(instance){
      this.instancesSelected = instance
    },
    selectExcludeCustomersId(customerIds){
      this.excludeCustomersIdSelected = customerIds
    },
    clear(all = true){
      this.instancesSelected = [0];
      this.categoriesSelected = [0];
      this.excludeCustomersIdSelected = [0];

      if (all){
        this.tenantInput = null;
        this.showTenantInput = false;

        const keys = Object.keys(this.filters);
        keys.forEach((key) => this.filters[key].active = false );
      }
    },
    filterDateAnalytics(){
      this.buttonDisabled = true
      setTimeout(() => { this.buttonDisabled = false }, 2000)
      this.loadMetabase()
    },
    loadMetabase(){
      this.dashFilter.map(([key, data]) => {
        this.payload.params = this.updateArgs();
        this.payload.resource = {dashboard: data['dashboard']}
        let token = jwt.sign(this.payload,  process.env.VUE_APP_METABASE_SECRET_KEY, '', '');
        this.typesOfDash[key]['url'] = process.env.VUE_APP_METABASE_SITE_URL + "/embed/dashboard/" + token + "#bordered=false&titled=false";
      })
    },
    updateArgs() {
      let params =  {
        'department_ids': '0',
        'data_final': this.finishDate,
        'data_inicial' : this.initialDate,
        'instance_ids': this.instancesSelected.toString(),
        'groups_of_customer_id': this.categoriesSelected.toString(),
        'tenant_ids': !this.showTenantInput ? this.hostnames.toString() : '0',
        'tenant': this.showTenantInput && this.tenantInput ? this.tenantInput : null
      }

      if (this.isMariaPanel){
        params = Object.assign(params, {
          'exclude_customer_ids': this.excludeCustomersIdSelected.toString()
        });
      }

      return params;
    }
  },
  async beforeMount() {
    const today = new Date()
    const yyyy = today.getFullYear()
    const mm = String(today.getMonth() + 1).padStart(2, '0')
    const todayDay = String(today.getDate()).padStart(2, '0')

    if ( !this.tenants.length ){
      await this.$store.dispatch('getAllTenants', { token: this.token })
    }

    this.initial_date = `${todayDay}/${mm}/${yyyy}`
    this.finish_date = `${todayDay}/${mm}/${yyyy}`
    this.hostnames = this.tenants.length > 0 ? [this.tenants[0].id] : []

    this.clear();
    this.loadMetabase();
  },
  beforeDestroy() {
    this.clear();
    if (this.autoSyncData || this.autoSync){
      clearInterval(this.autoSyncData);
      this.autoSyncData = null;
      this.autoSync = false;
    }
  },
  mounted(){
    this.verify()
  }
}
</script>

<style lang="scss">

#dashboard-analytics {
  .loading-dashboard-graphs {
    height: 11rem;
    width: 100%;
  }

  .iframe{
    width: 100%;
    border: none;
    display: block;
    overflow-y: auto;
    border-radius: 20px;
    overflow-x: hidden;
    box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
  }

  .iframe-campaigns{
    height: 40vw;
  }

  .iframe-dafault{
    height: 235vw;
  }

  .iframe-cloud{
    height: 60vw;
  }

  .iframe-maria{
    height: 350vw;
  }

  .iframe-control-panel{
    height: 150vw;
  }

  @media(max-width: 1230px) {
    .iframe-dafault{
      height: 390vw !important;
    }

    .iframe-campaigns{
      height: 60vw;
    }

    .iframe-cloud{
      height: 250vw !important;
    }

    .iframe-maria{
      height: 470vw;
    }

    .iframe-control-panel{
      height: 270vw  !important;
    }
  }

  @media(max-width: 920px) {
    .iframe-dafault{
      height: 410vw !important;
    }

    .iframe-cloud{
      height: 300vw !important;
    }

    .iframe-campaigns{
      height: 120vw;
    }

    .iframe-maria{
      height: 690vw !important;
    }

    .iframe-control-panel{
      height: 320vw  !important;
    }
  }

  @media(max-width: 750px) {
    .iframe-dafault{
      height: 1200vw !important;
    }

    .iframe-control-panel{
      height: 480vw  !important;
    }
  }
  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 340px;
    }
    .iframe-dafault{
      height: 1890vw !important;
    }
  }
}

</style>
